"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modelResultMetadataDetail = exports.navWarningPill = exports.navNextStepButton = exports.navNextStepContainer = exports.navSubMenuCircle = exports.navMenuCircle = exports.navVerticalLine = exports.navTextHighlighted = exports.navTextClickable = exports.navSubMenuText = exports.navMenuText = exports.navRow = exports.navSubMenuContainer = exports.navMenuContainer = exports.navTrackerContainer = exports.SUBMENU_WARNING_COLOR = exports.SUBMENU_ACTIVE_COLOR = exports.SUBMENU_DEFAULT_COLOR = exports.NAVIGATION_DISABLED_COLOR = exports.NAVIGATION_ACTIVE_COLOR = exports.NAVIGATION_ENABLED_COLOR = void 0;
require("@tableau/fonts-tableau");
var prediction_model_results_viz_1 = require("@tableau/prediction-model-results-viz");
var StyleHelper_1 = require("./StyleHelper");
exports.NAVIGATION_ENABLED_COLOR = '#1C7ABE';
exports.NAVIGATION_ACTIVE_COLOR = '#209CE4';
exports.NAVIGATION_DISABLED_COLOR = prediction_model_results_viz_1.VizColors.tableauGray09;
exports.SUBMENU_DEFAULT_COLOR = prediction_model_results_viz_1.VizColors.tableauGray09;
exports.SUBMENU_ACTIVE_COLOR = '#209CE4';
exports.SUBMENU_WARNING_COLOR = '#FECA63';
exports.navTrackerContainer = (0, StyleHelper_1.cssClass)('nav-tracker-container', {});
exports.navMenuContainer = (0, StyleHelper_1.cssClass)('nav-menu-container', {});
exports.navSubMenuContainer = (0, StyleHelper_1.cssClass)('nav-submenu-container', {});
var fontCommon = {
    fontStyle: 'normal',
    fontWeight: 350,
    letterSpacing: '0.2px',
};
exports.navRow = (0, StyleHelper_1.cssClass)('nav-row', {
    display: 'flex',
    alignItems: 'center',
});
exports.navMenuText = (0, StyleHelper_1.cssClass)('nav-menu-text', __assign(__assign({}, fontCommon), { marginLeft: '8px', color: prediction_model_results_viz_1.VizColors.tableauGray11, fontSize: '16px', lineHeight: '24px' }));
exports.navSubMenuText = (0, StyleHelper_1.cssClass)('nav-submenu-text', __assign(__assign({}, fontCommon), { marginLeft: '8px', color: prediction_model_results_viz_1.VizColors.tableauGray11, fontSize: '14px', lineHeight: '21px' }));
exports.navTextClickable = (0, StyleHelper_1.cssClass)('nav-text-clickable', {
    cursor: 'pointer',
});
exports.navTextHighlighted = (0, StyleHelper_1.cssClass)('nav-text-highlighted', {
    color: prediction_model_results_viz_1.VizColors.tableauGray14,
});
exports.navVerticalLine = (0, StyleHelper_1.cssClass)('nav-vertical-line', {
    width: '1px',
    height: '32px',
    backgroundColor: prediction_model_results_viz_1.VizColors.tableauGray09,
    margin: '0 16px',
});
exports.navMenuCircle = (0, StyleHelper_1.cssClass)('nav-menu-circle', {
    width: '32px',
    height: '32px',
    backgroundColor: '#1C7ABE',
    borderRadius: '52px',
    position: 'relative',
    $nest: {
        '& > span': __assign(__assign({}, fontCommon), { position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', margin: 0, color: '#fff', fontSize: '16px', lineHeight: '24px' }),
    },
});
exports.navSubMenuCircle = (0, StyleHelper_1.cssClass)('nav-submenu-circle', {
    width: '10px',
    height: '10px',
    borderRadius: '22px',
    marginLeft: '11px',
});
exports.navNextStepContainer = (0, StyleHelper_1.cssClass)('nav-next-step', __assign(__assign({}, fontCommon), { fontSize: '16px', display: 'flex', alignItems: 'center' }));
exports.navNextStepButton = (0, StyleHelper_1.cssClass)('nav-next-step', __assign(__assign({}, fontCommon), { fontSize: '16px', display: 'flex', alignItems: 'center', color: prediction_model_results_viz_1.VizColors.textLinkDefault, marginRight: '5px', $nest: {
        '& > span': {
            marginRight: '5px',
        },
    } }));
exports.navWarningPill = (0, StyleHelper_1.cssClass)('nav-warning-pill', {
    display: 'inline-block',
    borderRadius: '12px',
    padding: '0 10px',
    marginLeft: '8px',
    backgroundColor: exports.SUBMENU_WARNING_COLOR,
});
// Model Result specific metadata style
exports.modelResultMetadataDetail = (0, StyleHelper_1.cssClass)('model-result-metadata-detail', __assign(__assign({ fontSize: '12px', lineHeight: '18px' }, fontCommon), { color: prediction_model_results_viz_1.VizColors.tableauGray11, display: 'flex', marginBottom: '5px', $nest: {
        '& div:first-child': {
            fontWeight: 500,
        },
    } }));
//# sourceMappingURL=NavigationPanel.js.map